import {Action} from 'redux';
import {isType} from 'typescript-fsa';
import * as actions from './actions';
import {UserState} from './types';

const initialState: UserState = {
  users: [],
  pending: false,
  success: false,
};

export const userReducer = (state = initialState, action: Action): UserState => {
  if (isType(action, actions.getUsersAction.started)) {
    return {
      ...state,
      pending: true,
    };
  }

  if (isType(action, actions.getUsersAction.done)) {
    return {
      ...state,
      users: action.payload.result,
      pending: false,
    };
  }

  if (isType(action, actions.getUsersAction.failed)) {
    return {
      ...state,
      pending: false,
    };
  }

  return state;
};
